
const app = {
    namespaced: true,

    state: {
        loading: false,

        snackbar: {
            visibile: false,
            testo: '',
            tipo: 'error'  // 'error' | 'success' | 'warning'
        }
    },

    mutations: {

        SET_LOADING(state, vis) {
            state.loading = vis
        },

        showMessage(state, { testo, tipo = 'error' }) {
            state.snackbar.testo = testo
            state.snackbar.tipo = tipo
            state.snackbar.visibile = true
        },
        hideMessage(state) {
            state.snackbar.visibile = false
        }

    },


}

export default app